/* Vendored copy of Versio (VSO Theme Sections) extension runtime
   (versioSections.js + versioSectionsPremium.css, extension version
   versio-smart-blocks-67), saved 2026-09-02 so the theme's vso-* sections
   render without the app installed. */
function vsInitialize() {
  if (document.readyState !== "loading") {
    vsOnReady(); // Initial run for the whole document
  } else {
    document.addEventListener("DOMContentLoaded", () => vsOnReady()); // Initial run
  }

  // Handle Shopify Theme Editor updates
  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      const sectionId = event.detail.sectionId;
      if (sectionId) {
        // Find the specific section container
        const sectionContainer = document.getElementById(
          `shopify-section-${sectionId}`
        );
        if (sectionContainer) {
          // Re-run initialization specifically for the loaded/updated section
          vsOnReady(sectionContainer);
        } else {
          // Fallback if specific container not found (less likely but safe)
          console.warn(
            `Versio section container not found for ID: ${sectionId}. Re-initializing all.`
          );
          vsOnReady();
        }
      } else {
        // Fallback if no sectionId (might happen on full page reload in editor)
        vsOnReady();
      }
    });

    // Consider adding listeners for block events if necessary, though section:load covers most edits.
    // document.addEventListener("shopify:block:select", (event) => { /* ... */ });
    // document.addEventListener("shopify:block:deselect", (event) => { /* ... */ });
  }
}

function vsOnReady(container = document) {
  // Accept an optional container element
  try {
    // Query within the specified container, defaulting to the whole document
    container.querySelectorAll(".vso-node").forEach((element) => {
      // Ensure the class is added, even if re-rendering removed it
      if (!element.classList.contains("vso-node--v2")) {
        element.classList.add("vso-node--v2");
      }
    });
    // Set the flag indicating the extension script has run
    window.versioExtensionLoaded = true;
    // Find and remove "vso-hidden" on all elements within the container
    container.querySelectorAll(".vso-hidden").forEach((el) => {
      el.classList.remove("vso-hidden");
    });
    container.querySelectorAll(".vso-require-script").forEach((el) => {
      el.remove();
    });
  } catch (error) {
    console.warn("Versio sections initialization failed:", error);
  }
}

vsInitialize();
